import { useAppContext } from 'use-app';
import styles from './index.module.sass';
import iconOilPricing from 'assets/icon_oil_pricing.svg';

const OilPricing = () => {
  const { state: appState } = useAppContext();
  let currentPricing = appState.oilPricing?.current || {};
  let predictPricing = appState.oilPricing?.predict || {};
  let pricing = text => {
    if (text === '+0.0') {
      return '不變';
    }
    if (text.includes('+')) {
      return `漲 ${text.replace('+', '')}`;
    } else if (text.includes('-')) {
      return `降 ${text.replace('-', '')}`;
    }
  };

  const formatter = price => {
    return parseFloat(price).toFixed(1);
  };

  return (
    <div className={styles['oil-pricing']}>
      <img src={iconOilPricing} alt="oil-pricing" />
      <div className={styles.pricing}>
        <ul>
          <li>
            <span>92汽</span>
            <span>{formatter(currentPricing['gas_92'])}</span>
          </li>
          <div className={styles.divider} />
          <li>
            <span>95汽</span>
            <span>{formatter(currentPricing['gas_95'])}</span>
          </li>
          <div className={styles.divider} />
          <li>
            <span>98汽</span>
            <span>{formatter(currentPricing['gas_98'])}</span>
          </li>
          <div className={styles.divider} />
          <li>
            <span>柴油</span>
            <span>{formatter(currentPricing['diesel'])}</span>
          </li>
        </ul>
        {appState.oilPricing && (
          <div className={styles.predict}>
            下週油價預測：汽油{pricing(predictPricing['gas_92'])}．柴油{pricing(predictPricing['diesel'])}
          </div>
        )}
      </div>
    </div>
  );
};

export default OilPricing;
